<template>
	<div class="ncontrol-container nk-control" :class="[isNumber ? 'nk-input-number' : 'nk-input-string', settings.searchable ? 'nk-input-searchable' : '', { 'has-icon': hasIcon }]" @focus="onFocused" :tabindex="disabled ? 0 : tabindex">
		<input :placeholder="disabled ? null : settings.placeholder" :startup="startup ? true : null" :disabled="disabled ? true : null" :maxlength="localMaxLength" :value="inputValue" :autocomplete="!!autocomplete ? 'on' : 'new-password'" :type="inputType" @input="onChanged" @focus="onFocused" @blur="onBlur" ref="input" :style="{ height: settings.height }"
			:class="{ 'ncontrol': ancestorName != 'cells', 'ncontrol-in-grid': ancestorName == 'cells', 'left-radius': !settings.searchable && !settings.icon && !settings.icon2, 'ltr': settings.ltr, ...settings.inputClasses, ...textAlign }" />
		<div class="ncontrol-icon" :class="{ 'input-disabled': disabled }" v-if="settings.icon || settings.icon2">
			<i v-if="settings.icon" :class="['icon fad', ' fa-' + settings.icon]"></i>
			<span v-if="settings.icon2" class="icon2">{{ settings.icon2 }}</span>
		</div>

		<div class="ncontrol-button" v-if="settings.searchable">
			<button type="button" tabindex="-2" :disabled="disabled ? true : null" @click="onSearchButtonClicked">
				<icon icon="search" group="light" />
			</button>
		</div>

		<!--<slot name="feedback"></slot>-->
	</div>
</template>
<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import Inputmask from 'inputmask'
	import $sc from '~/plugins/shortcut.collection.js'

	const Types = {
		STRING: 'string',
		PASSWORD: 'password',
		NUMBER: 'number',
		NEGATIVE_NUMBER: 'nnumber',
		FLOAT: 'float',
		NEGATIVE_FLOAT: 'nfloat',
		MONEY: 'price',
		NegativeMoney: 'negativePrice',
		CODE: 'code',
		PERCENT: 'percent',
		STRING_NUMBER: 'strnumber',
		INTEGER: 'integer',
		NEGATIVE_INTEGER: 'ninteger',
		Date: 'date',
		Time: 'time'
	}

	const MAXINTVALUE = 2147483647 // 2,147,483,647
	const MININTVALUE = -2147483647 // -2,147,483,647

	export default {
		name: 'nikan-input',
		props: {
			options: { type: Object },
			modelValue: { type: [String, Number] },
			tabindex: { type: [String, Number, Boolean] },
			startup: { type: Boolean },
			disabled: { type: Boolean, default: false },
			required: { type: Boolean },
			maxlength: { type: Number },
			autocomplete: { type: Boolean },
			small: { type: Boolean, default: false },
			ancestorName: { type: String, default: null },
		},
		emits: ['on-change', 'focus', 'searchClick', 'blur', 'update:modelValue'],
		data() {
			return {
				settings: {
					maxlength: 200,
					mode: 'string',
					placeholder: '',
					decimals: 0,
					specialChars: [],
					ltr: false,
					emitInitValue: false,
					inputClasses: {},
				},
				pauseGetValue: false,
				pVal: '',
			}
		},
		computed: {
			localMaxLength() {
				return this.maxlength || this.settings.maxlength
			},
			hasIcon() {
				return this.settings.icon || this.settings.icon2 || (this.settings.searchable && !this.disabled)
			},
			isRequired() {
				if (this.settings.required || this.required) {
					return true
				}
				return false
			},
			isNumber() {
				switch (this.settings.mode) {
					case Types.NUMBER:
					case Types.NEGATIVE_NUMBER:
					case Types.FLOAT:
					case Types.NEGATIVE_FLOAT:
					case Types.MONEY:
					case Types.CODE:
					case Types.INTEGER:
					case Types.NEGATIVE_INTEGER:
					case Types.STRING_NUMBER:
						return true
					case Types.STRING:
					case Types.PASSWORD:
					default:
						return false
				}
			},
			textAlign() {
				var test = ['text-left', 'text-right']
				if ((this.isNumber || this.settings.mode === Types.PERCENT) && !Object.keys(this.settings.inputClasses || {}).some(x => test.includes(x))) {
					return { 'text-left': true }
				}
				return {}
			},
			input() {
				return this.$refs.input
			},
			inputType() {
				switch (this.settings.mode) {
					case Types.PASSWORD:
						return 'password'
					default:
						return 'text'
				}
			},
			inputValue: {
				get: function () {
					let v = this.pVal || this.pVal === 0 ? String(this.pVal) : ''
					if ((this.settings.mode == Types.MONEY && !this.settings.decimals) || this.settings.mode === Types.NegativeMoney) v = v.replace(/\.0+$/, '')
					return v
				},
				set: function (val) {
					this.pVal = val
				},
			},
		},
		watch: {
			options: {
				deep: true,
				handler(val, oldVal) {
					if (this.pauseGetValue === true) {
						this.pauseGetValue = false
						return
					}

					if (val.onChangeHandler)
						oldVal.onChangeHandler = val.onChangeHandler // Note: because functions are compared by reference, not by their content, so the comparison will always be false due to onChangeHandler is a function

					if (!_.isEqual(val, oldVal)) {
						this.defer(() => {
							this.cloneSettings(val)
						}, 100)
					}
				},
			},
			'options.decimals': {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (!_.isEqual(val, oldVal)) {
						this.defer(() => {
							this.cloneSettings(this.options)
							this.onFocused()
						}, 100)
					}
				},
			},
			modelValue: {
				handler(val) {
					if (this.pauseGetValue === true) {
						this.pauseGetValue = false
						return
					}
					this.inputValue = val
				},
			},
		},
		created() { },
		mounted() {
			this.cloneSettings(this.options)
			this.inputValue = this.modelValue

			if (this.settings.emitInitValue) {
				this.defer(() => this.onChanged(), 10)
			}

			Inputmask.extendDefinitions({
				9: {
					validator: '[0-9\uff11-\uff19۰-۹]',
					definitionSymbol: '*',
				},
			})
		},
		methods: {
			cloneSettings(val) {
				this.settings = _.extend({}, this.settings, val)

				if (this.isNumber || this.settings.type === Types.PERCENT)
					this.settings.ltr = true

				if (this.input.inputmask) {
					this.input.inputmask.remove()
				}

				let maskOptions = { placeholder: '', rightAlign: false }
				switch (this.settings.mode) {
					case Types.Date:

						Inputmask({
							...maskOptions,
							regex: '(((1[2-4][0-9][0-9]))\/((0[0-9])|(1[012]))\/((0[1-9])|([1-2][0-9])|(3[0-1]))){1,10}$',
							// rightAlign: true,
							// placeholder:'-',
							// min: this.settings.min ? this.settings.min : 0,
							// max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.STRING_NUMBER:
						let regex = ''
						if (
							this.settings.specialChars &&
							this.settings.specialChars.length > 0
						) {
							regex = this.settings.specialChars.join('')
							regex = '[0-9۰-۹' + regex + ']+'
						} else {
							regex = '[0-9۰-۹]+'
						}
						Inputmask({
							...maskOptions,
							regex: regex,
							min: this.settings.min ? this.settings.min : MININTVALUE,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.NUMBER:
						Inputmask("numeric", {
							...maskOptions,
							allowMinus: false,
							min: this.settings.min ? this.settings.min : 0,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.NEGATIVE_NUMBER:
						Inputmask("numeric", {
							...maskOptions,
							allowMinus: true,
							min: this.settings.min ? this.settings.min : 0,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.INTEGER:
						Inputmask("numeric", {
							...maskOptions,
							allowMinus: false,
							digits: 0,
							min: this.settings.min ? this.settings.min : 0,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.NEGATIVE_INTEGER:
						Inputmask("numeric", {
							...maskOptions,
							rightAlign: true,
							allowMinus: true,
							min: this.settings.min ? this.settings.min : MININTVALUE,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.FLOAT:
						Inputmask({
							...maskOptions,
							alias: 'decimal',
							autoGroup: false,
							allowMinus: false,
							min: this.settings.min ? this.settings.min : 0,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.NEGATIVE_FLOAT:
						Inputmask({
							...maskOptions,
							alias: 'decimal',
							autoGroup: false,
							allowMinus: true,
							min: this.settings.min ? this.settings.min : MININTVALUE,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.PERCENT:
						Inputmask("numeric", {
							...maskOptions,
							min: 0,
							max: 100,
							allowMinus: false,
							digits: this.settings.decimals ? this.settings.decimals : 3
						}).mask(this.input)
						break
					case Types.MONEY:
						this.getMoneyMask(false, maskOptions).mask(this.input)
						break
					case Types.NegativeMoney:
						this.getMoneyMask(true, maskOptions).mask(this.input)
						break
					case Types.CODE:
						Inputmask({
							...maskOptions,
							regex: '([0-9۰-۹]*-[0-9۰-۹]*)*[0-9۰-۹]*',
							min: this.settings.min ? this.settings.min : MININTVALUE,
							max: this.settings.max ? this.settings.max : MAXINTVALUE,
						}).mask(this.input)
						break
					case Types.Time:
						Inputmask({
							...maskOptions,
							mask: '9{1,3}:X9:00',
							clearIncomplete: true,
							definitions: {
								'X': { validator: "[0-5]" },
							},
							placeholder: '_',
							greedy: false,
						}).mask(this.input)
						break
					case Types.STRING:
					case Types.PASSWORD:
					default:
						if (this.input.inputmask) {
							this.input.inputmask.remove()
						}
						break
				}
			},
			pureValue() {
				if (
					this.settings.mode === Types.STRING ||
					this.settings.mode === Types.PASSWORD ||
					this.settings.mode === Types.CODE ||
					this.settings.mode === Types.STRING_NUMBER ||
					this.settings.mode === Types.Time
				) {
					return String(this.input.value).toEnglishDigits()
				} else if (this.settings.mode === Types.MONEY) {
					let value = this.input.inputmask.unmaskedvalue()
					if (this.settings.returnType === 'number')
						return Number(String(value).toEnglishDigits())
					else
						return String(value).toEnglishDigits()
				} else if (this.input.inputmask) {
					let value = this.input.inputmask.unmaskedvalue()
					return Number(String(value).toEnglishDigits())
				} else {
					return String(this.input.value).toEnglishDigits()
				}
			},

			onSearchButtonClicked() {
				if (
					this.settings.onSearchButtonClicked != null &&
					_.isFunction(this.settings.onSearchButtonClicked)
				) {
					this.settings.onSearchButtonClicked()
				}

				this.$emit('searchClick')
			},
			onFocused() {
				if (!$(this.input).is(':focus')) {
					this.input.focus()
				}
				this.defer(() => {
					if ($(this.input).is(':focus')) {
						this.input.select()
					}
				}, 10)
				this.$emit('focus')
			},
			onChanged() {
				let pureValue = this.pureValue()
				this.emit(pureValue)
				this.$emit('on-change', pureValue)
			},
			onBlur() {
				if (this.settings.mode === Types.Time && !this.input.inputmask?.isValid()) {
					this.emit('')
				}
				if (this.settings.mode === Types.MONEY && this.input?.value.endsWith('.')) {
					let pureValue = this.pureValue()
					this.emit(pureValue.replace('.', ''))
				}

				this.$emit('blur')
			},

			emit(value) {
				this.pauseGetValue = true
				this.inputValue = this.getMaskedValue(value)
				this.$emit('update:modelValue', value)
				if (this.settings.onChangeHandler && typeof this.settings.onChangeHandler == 'function') {
					this.settings.onChangeHandler(value)
				}
			},
			getMaskedValue(value) {
				if (this.settings.mode === Types.MONEY) {
					return this.getMoneyMask().format(value) + (this.input.value.endsWith('.') ? '.' : '')
				}

				if (this.settings.mode === Types.NegativeMoney) {
					return this.getMoneyMask(true).format(value) + (this.input.value.endsWith('.') ? '.' : '')
				}

				return value
			},
			getMoneyMask(allowMinus = false, maskOptions = {}) {
				return Inputmask({
					...maskOptions,
					alias: 'currency',
					prefix: '',
					digits: this.options.decimals,
					digitsOptional: true,
					allowMinus: allowMinus,
					min: this.settings.min ? this.settings.min : null,
					max: this.settings.max ? this.settings.max : 922337203685477,
					shortcuts: null,
					onKeyDown: (e) => {
						if ((e.key === 'Delete' || e.keyCode === 46) && (e.ctrlKey || e.altKey || e.shiftKey)) {
							e.preventDefault()
							return true
						}
					}
				})
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'nikan-input-search-button',
					shortcut: $sc.find('enter'),
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						this.onSearchButtonClicked()
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-plus-3-zero',
					shortcut: $sc.find('3zero', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						const pureValue = this.pureValue()

						if (!pureValue || pureValue === '0')
							return false

						if (this.settings.max && parseFloat(this.settings.max) < parseFloat(pureValue + '000'))
							return false

						return this.settings.mode === Types.MONEY
					},
					handler: function (sender, e) {
						e.preventDefault()
						let pureValue = this.pureValue()
						pureValue += '000'
						this.emit(pureValue)

						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-plus-2-zero',
					shortcut: $sc.find('2zero', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						const pureValue = this.pureValue()

						if (!pureValue || pureValue === '0')
							return false

						if (this.settings.max && parseFloat(this.settings.max) < parseFloat(pureValue + '00'))
							return false

						return this.settings.mode === Types.MONEY
					},
					handler: function (sender, e) {
						e.preventDefault()

						let pureValue = this.pureValue()
						pureValue += '00'
						this.emit(pureValue)

						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-selectAll',
					shortcut: $sc.find('selectAll', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						e.preventDefault()
						this.onFocused()
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-copy',
					shortcut: $sc.find('copy', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						e.preventDefault()
						var selectedText = ""
						if (window.getSelection) {
							selectedText = window.getSelection().toString()
						}
						if (navigator.clipboard) {
							navigator.clipboard.writeText(selectedText)
						} else {
							var textarea = document.createElement("textarea")
							textarea.value = selectedText
							document.body.appendChild(textarea)
							textarea.select()
							try {
								document.execCommand("copy")
							} catch (err) {
								console.error("Fallback: unable to copy", err)
							}
							document.body.removeChild(textarea)
						}
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-cut',
					shortcut: $sc.find('cut', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						e.preventDefault()
						var selectedText = ""
						if (window.getSelection) {
							selectedText = window.getSelection().toString()
						}
						navigator.clipboard.writeText(selectedText)
						this.emit('')
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-paste',
					shortcut: $sc.find('paste', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: async function (sender, e) {
						this.inputValue = this.getMaskedValue(this.input.value)
						this.defer(() => {
							let pureValue = this.pureValue()
							this.emit(pureValue)
							this.pauseGetValue = false
						}, 5)
						return false
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-left-arrow',
					shortcut: $sc.find('left', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						if (e.target.selectionStart != e.target.selectionEnd) return true
						if (this.settings.ltr) return e.target.selectionStart != 0
						return e.target.selectionStart < $(this.input).val().length
					},
				})
				this.$keyHandler.Subscribe({
					name: 'nikan-input-right-arrow',
					shortcut: $sc.find('right', 'input'),
					el: this.$el,
					context: this,
					test: function () {
						return true
					},
					handler: function (sender, e) {
						if (e.target.selectionStart != e.target.selectionEnd) return true
						if (this.settings.ltr)
							return e.target.selectionStart < $(this.input).val().length
						return e.target.selectionStart != 0
					},
				})
			},
		},
	}
</script>
<style>
	.nikan-input {
		z-index: 1;
	}

	.nikan-input .btn {
		border-radius: 0.25rem 0 0 0.25rem !important;
	}

	.nikan-input.nk-input-searchable .form-control {
		border-radius: 0 0.25rem 0.25rem 0 !important;
	}

	.nikan-input.nk-input-string input {
		direction: rtl;
		text-align: right;
	}

	.nikan-input.nk-input-number input {
		direction: ltr;
		text-align: right;
	}

	.input-disabled {
		background-color: #e9ecef !important;
		opacity: 1 !important;
	}

	.input-disabled i {
		opacity: 0.65 !important;
	}
</style>
